import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { WisetackDisclosure } from '@/components/shared/WisetackDisclosure';
import { WISETACK_BRAND } from '@/lib/wisetack/brand';
import type { PublicWisetackCta } from '@/types/public';

/** Shared public prequalification placement; never an acceptance or payment action. */
export function WisetackPublicCta({
  wisetack,
  description = 'Prequalify to see available payment options before approving this estimate.',
}: {
  wisetack: PublicWisetackCta;
  description?: string;
}) {
  return (
    <section aria-label="Wisetack financing" className="space-y-3" data-testid="wisetack-cta">
      <div className="flex items-start gap-3">
        <img
          src="/brand/integrations/wisetack.png"
          alt="Wisetack"
          className="mt-0.5 size-8 shrink-0 object-contain"
        />
        <div className="min-w-0">
          <h3 className="text-sm font-semibold" style={{ color: WISETACK_BRAND.space }}>
            Wisetack financing
          </h3>
          <p className="mt-0.5 text-xs text-gray-500">{description}</p>
        </div>
      </div>
      <Button
        asChild
        className="w-full text-white hover:opacity-90"
        style={{ backgroundColor: WISETACK_BRAND.sapphire }}
      >
        <a href={wisetack.ctaUrl} target="_blank" rel="noreferrer">
          See Financing Options
          <ExternalLink className="size-4" />
        </a>
      </Button>
      <WisetackDisclosure
        disclosure={wisetack.disclosure}
        className="text-[11px] leading-4 text-gray-500"
      />
    </section>
  );
}
